import React, { useEffect, useRef } from "react";
import { motion, useInView } from "framer-motion";
import website from "../../Assets/website.jpeg"
import "./Website.css";

const Website = () => {

    const ref1 = useRef(null);
    const ref2 = useRef(null);
    const ref3 = useRef(null);
    const ref4 = useRef(null);

    // Check when each box comes into view
    const inView1 = useInView(ref1, { once: true, threshold: 0.2 });
    const inView2 = useInView(ref2, { once: true, threshold: 0.2 });
    const inView3 = useInView(ref3, { once: true, threshold: 0.2 });
    const inView4 = useInView(ref4, { once: true, threshold: 0.2 });

    const boxVariants = {
        hidden: { opacity: 0, y: 50 },
        visible: (delay) => ({
            opacity: 1,
            y: 0,
            transition: { duration: 0.5, delay }
        }),
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <>
            <div className="web-container">
                <div className="web-topic">
                    <h1>Website development</h1>
                </div>
                <div className="def">
                    <span className="def-content">Website development for a company involves creating a professional, user-friendly online platform that showcases its services, enhances brand credibility, and drives customer engagement.
                        For a marketing firm, this means designing a visually appealing, SEO-optimized website with compelling content, lead generation forms, and analytics integration to track visitor behavior.
                        A well-developed website helps attract potential clients, establish authority, and convert leads into customers efficiently.
                    </span>
                </div>
                <div className="DM-benefits" style={{ marginLeft: "5%" }}>
                    <h2 className="DM-question">Benefits of developing a website for your comcpany:-</h2>
                    <div className="fullDM-content" style={{gap:"5px"}}>
                        <span className="DM-content" style={{ marginTop: "15px", flexDirection: "column" }}>Having a website for your company is essential in today’s digital world, as it helps establish a
                            strong online presence and drive business growth. Here are some key benefits of developing a website for your company:
                            <ul className="ul-points">
                                <li className="point">Increased Visibility – A website makes your business accessible to a global audience 24/7.</li>
                                <li className="point">Brand Credibility – A professional website builds trust and enhances your brand’s reputation.</li>
                                <li className="point">Lead Generation & Sales – An optimized site attracts potential customers and helps convert them into clients.</li>
                                <li className="point">Marketing & Advertising – Digital marketing efforts, such as SEO and social media, drive traffic to your site.</li>
                                <li className="point">Customer Engagement – Features like blogs, contact forms, and live chat improve communication with customers.</li>
                                <li className="point">Competitive Advantage – A well-designed website helps you stand out from competitors in your industry.</li>
                            </ul>
                        </span>
                        <div className="digi-image">
                            <img style={{ width: "350px", height: "450px", marginTop:"35px" }} className="apps-img" src={website} alt="apps" />
                        </div>
                    </div>
                </div>
                <div className="DM-benefits">
                    <h1 className="DM-nextquestion">Services we provide to upscale your business !</h1>
                    <div className="boxes">
                        <motion.div
                            ref={ref1}
                            initial="hidden"
                            animate={inView1 ? "visible" : "hidden"}
                            variants={boxVariants}
                            custom={0}
                            className="point-box"
                        >
                            <h2 className="point-topic">Fully coded website</h2>
                            <span className="point-content">We provide services like custom website design, front-end and back-end development, and CMS integration to ensure a fully functional
                                and responsive website. They also offer SEO optimization,
                                performance testing, security implementation, and ongoing maintenance to enhance user experience and business growth.</span>
                        </motion.div>

                        <motion.div
                            ref={ref2}
                            initial="hidden"
                            animate={inView2 ? "visible" : "hidden"}
                            variants={boxVariants}
                            custom={0.3}
                            className="point-box"
                        >
                            <h2 className="point-topic">Website management and modification</h2>
                            <span className="point-content">Website management and modification services include regular updates, content changes, performance optimization, and
                                security monitoring to keep the site running smoothly. They also involve bug fixes, feature enhancements,
                                SEO improvements, and adapting the website to evolving business needs for better user experience and engagement.</span>
                        </motion.div>

                        <motion.div
                            ref={ref3}
                            initial="hidden"
                            animate={inView3 ? "visible" : "hidden"}
                            variants={boxVariants}
                            custom={0.6}
                            className="point-box"
                        >
                            <h2 className="point-topic">Landing pages</h2>
                            <span className="point-content">Landing page services include designing and developing high-converting, visually
                                appealing pages tailored for specific campaigns or offers. They focus on compelling content, clear CTAs, fast load times,
                                and SEO optimization to drive traffic, capture leads, and boost conversions effectively.</span>
                        </motion.div>

                        <motion.div
                            ref={ref4}
                            initial="hidden"
                            animate={inView4 ? "visible" : "hidden"}
                            variants={boxVariants}
                            custom={0.9}
                            className="point-box"
                        >
                            <h2 className="point-topic">UI designs</h2>
                            <span className="point-content">UI design services focus on creating visually appealing, user-friendly interfaces that enhance
                                the overall user experience. This includes wireframing, prototyping, color schemes, typography,
                                and responsive design to ensure seamless navigation and engagement across different devices and platforms.</span>
                        </motion.div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Website;